// extracted by mini-css-extract-plugin
export default {"normalButton":"styles_normalButton__QDWZw"};